import React from 'react';
import Headings from './sub_components/Headings'
import { useState , useEffect } from 'react';
import Container from './atoms/Container';
import axios from 'axios'
import { baseUrl } from '../utils.jsx/baseUrl'
import Pagination  from './sub_components/Pagination';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SinglepointLoadsTable from './sub_components/SinglepointLoadsTable';
import { Link } from 'react-router-dom';
import { useContext } from 'react';
import Contextapi from '../context-api/createContext';

const headers = [
  'Origin',
  'Destination',
  'Pickup Date',
  'Broker',
  'Equipment Type',
  'Posted By',
  'Last Updated On(CST)'
] 
 


function SinglepointLoads() {
  // const { setIsnavabr } = useContext(Contextapi);
 const [loads , setLoads ] = useState([])
 const [page , setPage ] = useState(1);
 const [size , setSize ] = useState(10)
 const [sort , setSort] = useState({updatedAt : -1})
 const token = localStorage.getItem("token")
async function getLoads(){
  try {
    const params = {
      page: page, 
      size: size, 
       sort : sort
    };
    const url = `${baseUrl.url}/singlepoint/loads/getAll`;

    const response = await axios.get(url, {
          params,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

    const data = response.data;
     setLoads(data);

  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

useEffect(() =>{
 (async() => {
  await getLoads()
  // setIsnavabr(true)
 })()
}, [page ])

 return (
  <>
  <div  className  = " ">
  <Container className="h-screen">
    <div className="grid rounded-md mb-4">
      <div className = "flex flex-cols gap-4 ">
    <Headings heading="Single Point Loads" title="Single Point offers an exclusive members-only load board" />
    <Link to = "/loadboard"><button className=" p-3 bg-[#000] text-white rounded-lg text-md justify-center items-center whitespace-nowrap">Back to Load Board</button></Link>
    </div>


  <SinglepointLoadsTable headers={headers}
   data={loads} 
     page = {page}/>



{loads?.data?.length != 0 && <Pagination  page = {page} setPage = {setPage}  info = { loads?.meta}  />}
  </div>
 
  </Container>
  <ToastContainer />
  </div>
  </>
 )
}

export default SinglepointLoads


